import Vapi from "vuex-rest-api"
import Timetable from "@/components/Timetable/models/Timetable"
import AppEvents from '@/AppEvents';

const timetableApi = new Vapi({
    baseURL: process.env.VUE_APP_API_HOST + "/api/timetable",
    state: {
        timetables: [],
        selectedTimetable: 0
    }
})
    .get({
        action: "getAllTimetables",
        property: "timetables",
        path: "/",
        onSuccess: (state, payload, axios) => {
            // console.log("getAllTimetables onSuccess", state, payload.data);
            state.timetables = payload.data.map(s => Timetable.fromApi(s));
        },
        onError: (state: any, error: any, axios: any) => {
            AppEvents.handleApiError(error);
        }
    })
    .get({
        action: "getDestinationTimetables",
        property: "timetables",
        path: ({ destinationId }) => ("/destination/" + destinationId),
        onSuccess: (state, payload, axios) => {
            // console.log("getDestinationTimetables onSuccess", state, payload.data);
            const apiTimetables: any[] = payload.data;
            apiTimetables.forEach((apiTimetable: any) => {
                const newTimetable =  Timetable.fromApi(apiTimetable);
                const index: number = state.timetables.findIndex(t => t.id === newTimetable.id);
                if (index > -1){
                    // timetable already exists, update props
                    Object.assign(state.timetables[index], newTimetable);
                } else {
                    // timetable does not exists, push it to the store
                    state.timetables.push(newTimetable);
                }
            });
        },
        onError: (state: any, error: any, axios: any) => {
            AppEvents.handleApiError(error);
        }
    })
    .get({
        action: "getTimetableById",
        property: "timetable",
        path: ({ id }) => ("/" + id),
        onSuccess: (state, payload, axios) => {
            // console.log("updateTimetable onSuccess", state, payload.data);
            const timetable = Timetable.fromApi(payload.data);
            const timetableIndex = state.timetables.findIndex(p => p.id === timetable.id);
            if (timetableIndex > -1) {
                // Timetable already exists, update props
                Object.assign(state.timetables[timetableIndex], timetable);
            } else {
                // Timetable does not exist, push it to state.timetables
                state.timetables.push(timetable);
            }
        },
        onError: (state: any, error: any, axios: any) => {
            AppEvents.handleApiError(error);
        }
    })
    .post({
        action: "createTimetable",
        property: "timetable",
        path: "/",
        onSuccess: (state, payload, axios) => {

            // console.log("createTimetable onSuccess", state, payload.data);
            const timetable = Timetable.fromApi(payload.data);
            state.timetables.push(timetable);
            // console.log("state.timetables is now:", state.timetables);
            return timetable;
        },
        onError: (state: any, error: any, axios: any) => {
            AppEvents.handleApiError(error);
        }
    })
    .put({
        action: "updateTimetable",
        property: "timetable",
        path: ({ id }) => ("/" + id),
        onSuccess: (state, payload, axios) => {
            // console.log("updateTimetable onSuccess", state, payload.data);
            const timetable = Timetable.fromApi(payload.data);
            const timetableIndex = state.timetables.findIndex(p => p.id === timetable.id);
            // Timetable already exists, update props
            if (timetableIndex > -1){
                Object.assign(state.timetables[timetableIndex], timetable);
            } else {
                console.error("Failed to update local timetable after response from API to an update request");
            }
        },
        onError: (state: any, error: any, axios: any) => {
            AppEvents.handleApiError(error);
        }
    })
    .delete({
        action: "deleteTimetable",
        property: "timetable",
        path: ({ id }) => ("/" + id),
        onSuccess: (state, payload, axios) => {
            // console.log("deletePassenger onSuccess", state, payload.data);
            const timetable = Timetable.fromApi(payload.data);
            const timetableIndex = state.timetables.findIndex(p => p.id === timetable.id);
            if (timetableIndex > -1){
                state.timetables.splice(timetableIndex, 1);
            } else {
                console.error("Failed to remove local timetable after response from API to a delete request");
            }
        },
        onError: (state: any, error: any, axios: any) => {
            AppEvents.handleApiError(error);
        }
    })
    .put({
        action: "undeleteTimetable",
        property: "timetable",
        path: ({ id }) => ("/undelete/" + id),
        onSuccess: (state, payload, axios) => {
            const timetable = Timetable.fromApi(payload.data);
            const timetableIndex = state.timetables.findIndex(p => p.id === timetable.id);
            if (timetableIndex > -1) {
                // Timetable already exists, update props
                Object.assign(state.timetables[timetableIndex], timetable);
            } else {
                // Timetable does not exist, push it to state.timetables
                state.timetables.push(timetable);
            }
        },
        onError: (state: any, error: any, axios: any) => {
            AppEvents.handleApiError(error);
        }
    })

const timetableStore = timetableApi.getStore();

// add selectedTimetable to the store
(timetableStore.state as any).selectedTimetable = 0
timetableStore.mutations.setSelectedTimetable = (state, value) => {
  state.selectedTimetable = value;
}
timetableStore.actions.setSelectedTimetable = (context, value) => {
  context.commit("setSelectedTimetable", value)
}

(timetableStore as any).namespaced = true;

export default timetableStore;
